var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "nav" }, [
      _c("img", {
        staticStyle: { "margin-right": "85px" },
        attrs: { src: require("../assets/logo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/" } }, [
          _vm._v(_vm._s(_vm.$t("nav_home")))
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/raceCenter" } }, [
          _vm._v(_vm._s(_vm.$t("nav_race")))
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/certificate" } }, [
          _vm._v(_vm._s(_vm.$t("nav_certificate")))
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/aboutus" } }, [
          _vm._v(_vm._s(_vm.$t("nav_about_us")))
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "https://www.icode.org.cn/racePartner" } }, [
          _vm._v(_vm._s(_vm.$t("nav_race_partner")))
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            staticStyle: { color: "#148bff" },
            attrs: { href: "javascript:;" }
          },
          [_vm._v(_vm._s(_vm.$t("nav_ohc")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "OH-code" }, [
      _c("section", [
        _c("p", { staticClass: "title" }, [
          _c("i", { staticClass: "icons" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("ohc_title")))]),
          _vm._v(" "),
          _c("i", { staticClass: "icons" })
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "OH-code-title" }, [
        _c("h1", { staticStyle: { "font-size": "30px" } }, [
          _vm._v(_vm._s(_vm.$t("ohc_subtitle")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "OH-code-link" }, [
          _c(
            "a",
            { attrs: { href: "https://t.1yb.co/bKCO", target: "_blank" } },
            [
              _c("span", [
                _c("i", { staticClass: "el-icon-question" }),
                _vm._v(_vm._s(_vm.$t("ohc_what_is")))
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "OH-code-content" }, [
        _c(
          "div",
          {
            staticClass: "courseBox",
            on: {
              mouseover: function($event) {
                _vm.playBlockyG()
              },
              mouseleave: function($event) {
                _vm.playBlockyJ()
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.playBlocky } }),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v(_vm._s(_vm.$t("ohc_blocky_no_code")))]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.$t("ohc_blocky_drag")))]),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v(_vm._s(_vm.$t("ohc_blocky_recommend")))])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "blocky",
                on: {
                  click: function($event) {
                    _vm.to_OHC(0, 123001, "OHblocky")
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("ohc_enter_blockly")) +
                    "\n          "
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "courseBox",
            on: {
              mouseover: function($event) {
                _vm.playPythonG()
              },
              mouseleave: function($event) {
                _vm.playPythonJ()
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.playPython } }),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v(_vm._s(_vm.$t("ohc_python_code")))]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.$t("ohc_python_ai")))]),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v(_vm._s(_vm.$t("ohc_python_recommend")))])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "py",
                on: {
                  click: function($event) {
                    _vm.to_OHC(1, 123002, "OHpython")
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("ohc_enter_python")) +
                    "\n          "
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ea92550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea92550","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ohcIndex.vue
// module id = null
// module chunks = 